var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "Sticky",
        {
          model: {
            value: _vm.isStickyHeader,
            callback: function ($$v) {
              _vm.isStickyHeader = $$v
            },
            expression: "isStickyHeader",
          },
        },
        [
          _c(
            "ul",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isStickyHeader,
                  expression: "isStickyHeader",
                },
              ],
              staticClass: "tabs hkld-tabs",
              attrs: { id: "bid-sticky-tabs", "data-tabs": "" },
            },
            [
              _c("div", [
                _c(
                  "div",
                  {
                    staticClass: "tabs-title sticky-tabs-nav",
                    attrs: { id: "tabs-nav" },
                  },
                  [
                    _c(
                      "a",
                      {
                        directives: [
                          {
                            name: "checkVisibility",
                            rawName: "v-checkVisibility",
                          },
                        ],
                        staticClass: "is-active-tab",
                        on: {
                          click: function ($event) {
                            return _vm.navToTab("#bid-tab-general", $event)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("tender.generalTab")) +
                            "\n          "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isTender,
                            expression: "isTender",
                          },
                          {
                            name: "checkVisibility",
                            rawName: "v-checkVisibility",
                          },
                        ],
                        on: {
                          click: function ($event) {
                            return _vm.navToTab("#bid-tab-scope", $event)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("tender.scopeTab")) +
                            "\n          "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        directives: [
                          {
                            name: "checkVisibility",
                            rawName: "v-checkVisibility",
                          },
                        ],
                        on: {
                          click: function ($event) {
                            return _vm.navToTab("#bid-tab-services", $event)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("tender.sectionTab")) +
                            "\n          "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        directives: [
                          {
                            name: "checkVisibility",
                            rawName: "v-checkVisibility",
                          },
                        ],
                        on: {
                          click: function ($event) {
                            return _vm.navToTab("#bid-tab-attachment", $event)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("tender.attachmentTab")) +
                            "\n          "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        directives: [
                          {
                            name: "checkVisibility",
                            rawName: "v-checkVisibility",
                          },
                        ],
                        on: {
                          click: function ($event) {
                            return _vm.navToTab("#bid-tab-tnc", $event)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("tender.tncTab")) +
                            "\n          "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.showQuery,
                            expression: "showQuery",
                          },
                          {
                            name: "checkVisibility",
                            rawName: "v-checkVisibility",
                          },
                        ],
                        on: {
                          click: function ($event) {
                            return _vm.navToTab("#bid-tab-query", $event)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("summary.query.name")) +
                            "\n          "
                        ),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "float-right sticky-tender-tab-buttons" },
                  [_vm._t("default")],
                  2
                ),
              ]),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "create-tender-main" }, [
        _c(
          "ul",
          {
            staticClass: "row tabs hkld-tabs medium-column-5",
            attrs: { id: "bid-tabs", "data-tabs": "" },
          },
          [
            _c("li", { staticClass: "tabs-title is-active column" }, [
              _c(
                "a",
                {
                  directives: [
                    { name: "checkVisibility", rawName: "v-checkVisibility" },
                  ],
                  attrs: { href: "#bid-tab-general" },
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("tender.generalTab")) +
                      "\n        "
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _c(
              "li",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isTender,
                    expression: "isTender",
                  },
                ],
                staticClass: "tabs-title column",
              },
              [
                _c(
                  "a",
                  {
                    directives: [
                      { name: "checkVisibility", rawName: "v-checkVisibility" },
                    ],
                    attrs: { href: "#bid-tab-scope" },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("tender.scopeTab")) +
                        "\n        "
                    ),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c("li", { staticClass: "tabs-title column" }, [
              _c(
                "a",
                {
                  directives: [
                    { name: "checkVisibility", rawName: "v-checkVisibility" },
                  ],
                  attrs: { href: "#bid-tab-services" },
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("tender.sectionTab")) +
                      "\n        "
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "tabs-title column" }, [
              _c(
                "a",
                {
                  directives: [
                    { name: "checkVisibility", rawName: "v-checkVisibility" },
                  ],
                  attrs: { href: "#bid-tab-attachment" },
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("tender.attachmentTab")) +
                      "\n        "
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "tabs-title column" }, [
              _c(
                "a",
                {
                  directives: [
                    { name: "checkVisibility", rawName: "v-checkVisibility" },
                  ],
                  attrs: { href: "#bid-tab-tnc" },
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("tender.tncTab")) +
                      "\n        "
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _c(
              "li",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showQuery,
                    expression: "showQuery",
                  },
                ],
                staticClass: "tabs-title column",
              },
              [
                _c(
                  "a",
                  {
                    directives: [
                      { name: "checkVisibility", rawName: "v-checkVisibility" },
                    ],
                    attrs: { href: "#bid-tab-query" },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("summary.query.name")) +
                        "\n        "
                    ),
                  ]
                ),
              ]
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "hkld-tabs-content",
            attrs: { "data-tabs-content": "bid-tabs" },
          },
          [
            _c(
              "div",
              {
                staticClass: "tabs-panel is-active",
                attrs: { id: "bid-tab-general" },
              },
              [
                _c(
                  "div",
                  { staticClass: "grey lighten-5" },
                  [
                    _c("general", {
                      attrs: {
                        general: _vm.general,
                        isContractor: true,
                        tenderBidId: _vm.currentBidId,
                      },
                      on: {
                        "update:general": function ($event) {
                          _vm.general = $event
                        },
                      },
                    }),
                  ],
                  1
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isTender,
                    expression: "isTender",
                  },
                ],
                staticClass: "tabs-panel",
                attrs: { id: "bid-tab-scope" },
              },
              [
                _c("scope-of-work", {
                  attrs: { items: _vm.general.scopeOfWorks },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "tabs-panel", attrs: { id: "bid-tab-services" } },
              [
                _c("items-services-bid", {
                  ref: "itemsServicesTab",
                  attrs: {
                    itemServices: _vm.service,
                    bidService: _vm.bidService,
                    editView: false,
                  },
                  on: {
                    "update:bidService": function ($event) {
                      _vm.bidService = $event
                    },
                    "update:bid-service": function ($event) {
                      _vm.bidService = $event
                    },
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "tabs-panel",
                attrs: { id: "bid-tab-attachment" },
              },
              [
                _c("attachments", {
                  attrs: {
                    attachment: _vm.attachment,
                    tenderBidId: _vm.currentBidId,
                    tenderId: _vm.general.id,
                    zipPrefix: _vm.zipPrefix,
                    attachmentDesc: _vm.attachment.description,
                    editView: false,
                  },
                  on: {
                    "update:attachment": function ($event) {
                      _vm.attachment = $event
                    },
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "tabs-panel", attrs: { id: "bid-tab-tnc" } },
              [
                _c(
                  "div",
                  { staticClass: "grey lighten-5" },
                  [
                    _c("terms-conditions", {
                      ref: "termsConditionsTab",
                      attrs: {
                        isContractorView: true,
                        tenderId: _vm.general.id,
                        totalFee: _vm.bidService.totalFee,
                        tncInfo: _vm.tncInfo,
                        editView: false,
                        isTender: _vm.isTender,
                        zipName: _vm.zipNames.terms,
                      },
                      on: {
                        "update:tncInfo": function ($event) {
                          _vm.tncInfo = $event
                        },
                        "update:tnc-info": function ($event) {
                          _vm.tncInfo = $event
                        },
                      },
                    }),
                  ],
                  1
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "tabs-panel", attrs: { id: "bid-tab-query" } },
              [
                _c(
                  "div",
                  { staticClass: "grey lighten-5" },
                  [_vm.showQuery ? _c("tender-query-accordion") : _vm._e()],
                  1
                ),
              ]
            ),
          ]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }